export const storeRole = (role: string): void =>
  localStorage.setItem("role", role);
export const getRole = (): string | null => localStorage.getItem("role");
export const removeRole = (): void => localStorage.removeItem("role");

export const storeToken = (token: string): void =>
  localStorage.setItem("token", token);
export const getToken = (): string | null => localStorage.getItem("token");
export const removeToken = (): void => localStorage.removeItem("token");
export const storeStageNumber = (stage: string): void =>
  localStorage.setItem("stageNumber", stage);
export const getStageNumber = (): string | null =>
  localStorage.getItem("stageNumber");
export const removeStageNumber = (): void =>
  localStorage.removeItem("stageNumber");
export const storeOTPVerificationToken = (token: string): void =>
  localStorage.setItem("otpVerifiedToken", token);
export const getOTPVerificationToken = (): string | null =>
  localStorage.getItem("otpVerifiedToken");
export const removeOTPVerificationToken = (): void =>
  localStorage.removeItem("otpVerifiedToken");

export const storeEmail = (email: string): void =>
  localStorage.setItem("email", email);
export const getEmail = (): string | null => localStorage.getItem("email");
export const removeEmail = (): void => localStorage.removeItem("email");

export const storeApprovalStatus = (status: string): void =>
  localStorage.setItem("approvalStatus", status);
export const getApprovalStatus = (): string | null =>
  localStorage.getItem("approvalStatus");
export const removeApprovalStatus = (): void =>
  localStorage.removeItem("approvalStatus");

export const storeTab = (tab: string): void =>
  sessionStorage.setItem("tab", tab);
export const getTab = (): string | null => sessionStorage.getItem("tab");
